/**
 * @generated SignedSource<<953a9b684900c2fbccb91eb99ba0d524>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShopWrapper_landingPage$data = {
  readonly description: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ShopBreadcrumbs_landingPage" | "ShopCarousel_landingPage" | "ShopGrid_landingPage" | "ShopList_landingPage">;
  readonly " $fragmentType": "ShopWrapper_landingPage";
};
export type ShopWrapper_landingPage$key = {
  readonly " $data"?: ShopWrapper_landingPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShopWrapper_landingPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShopWrapper_landingPage",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShopBreadcrumbs_landingPage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShopCarousel_landingPage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShopGrid_landingPage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShopList_landingPage"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "LandingPage",
  "abstractKey": null
};

(node as any).hash = "c5f848ccd6bd9ad3c866e60059002613";

export default node;
